'use strict';

import Media from "./components/Media.js";
import Draggable from "./components/Draggable.js";
import {DatePicker} from "./components/DatePicker.js";
import {CountUpAnimation} from "./components/CountUpAnumation.js";
import {Modals} from "./components/Modals.js";


export class Components {
	/**
	 * Media component logic
	 * @param {{
	 *  hiddenInput: (HTMLElement|null),
	 *  openButton: (HTMLElement|null),
	 *  removeButton: (HTMLElement|null),
	 *  previewElement: ({
	 *      container: (HTMLElement|null),
	 *      selector: string,
	 *      removeButtonSelector: string,
	 *      template: string
	 *  }|HTMLElement|null),
	 *  mediaHeading: (string|{select?: string, change?: string}),
	 *  multipleSelect: boolean,
	 *  mediaSelectButtonText: (string|{select?: string, change?: string}),
	 *  blankImage: string,
	 *  attachmentSize: string,
	 *  showSelectedMediaOnReOpen: boolean,
	 *  disableRemoveButton: boolean,
	 *  buttonText: (string|{select?: string, change?: string}),
	 *  onOpen: Function,
	 *  onSelect: Function,
	 *  onRemove: Function,
	 *  onRemoveSingle: Function,
	 *  dataAccept string,
	 *  onClose: Function
	 * }} args
	 * @returns {Media}
	 */
	static media(args) {
		return new Media(args)
	}

	static draggable(args) {
		return new Draggable(args);
	}

	static datePicker(args) {
		return new DatePicker(args);
	}

	static countUpAnimation(duration = 2000, easing = 'ease-out') {
		return new CountUpAnimation(duration, 'ease-out');
	}

	static modals() {
		return new Modals();
	}
}
